import { getApiRequest } from 'api';
import { EventRoom } from 'api/services/proctoring';

export const getEventRoomDetails = (id: number): Promise<EventRoom> => {
    return getApiRequest(`/event-room/${id}/`);
};
